import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate,Link} from "react-router-dom";
import MainPageSkeleton from "../../../components/loaders/MainPageSkeleton";
import Container from '@mui/material/Container';
import {useParams} from "react-router";
import {currencySymbol, price, scrollTop, showTableDate} from "../../../../config/values";
import {connect, setStore} from "trim-redux";
import {updateRedux} from "../../../../config/Security";
import PaymentPageSkeleton from "../../../components/loaders/PaymentPageSkeleton";
import {Button, Divider, Typography} from "@mui/material";
import Courier from "../../../components/icons/Courier";
import {ArrowRight, Info,CircleCheckBig,CircleX} from "lucide-react";

function PaymentResultPage({classes,setting}){
    const { t } = useTranslation();
    let { code,platform,source } = useParams();

    const [page, setPage] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const navigation = useNavigate();
    const payment_redirect_url = localStorage.getItem("payment_redirect_url");
    const payment_redirect_text = localStorage.getItem("payment_redirect_text");
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        setFetching(true);
        axios.get(`${defaultVariables.url}/wallets/transaction/${code}`,config)
            .then(response => {
                setPage(response.data);
                setLoadError(false);
                updateRedux();
                setLoading(false);
                setFetching(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setPage((prev) => ({
                    ...(prev || {}),
                    status: "not_paid",
                    error: t("somethingWentWrong"),
                    description: "",
                    amount: 0,
                    unique_code: code,
                }));
                setLoadError(true);
                setLoading(false);
                setFetching(false);
            });
    }

    useEffect(() => {
        if (!fetching) {
            scrollTop();
            loadData();
        }
    },[]);

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('transaction') + " " + t(page?.status)}>
            <div className="page-color-layout">
                {
                    !!loading ?
                        <Container maxWidth="xl" >
                            <PaymentPageSkeleton/>
                        </Container>
                        :
                        <>
                            <Container maxWidth="lg">
                                <Grid container spacing={2} justifyContent="center" style={{marginTop:100,marginBottom:150}}>
                                    <Grid item size={{xs:12,md:8}} >

                                        <Grid container spacing={2}>
                                                <Grid item size={12} className="text-center">
                                                    {
                                                        page.status === "confirmed" ?
                                                            <CircleCheckBig className="lucide-icon-secondary lucide-transaction"/>
                                                            :
                                                            page.status === "not_paid" ?
                                                                <CircleX className="lucide-icon-primary lucide-transaction"/>
                                                                :
                                                                <Info/>
                                                    }
                                                    <h1 className="dialog-title">{t('transaction') + " " + t(page?.status)}</h1>
                                                    {
                                                        !!page.error &&
                                                        <Typography classname="error-text">{page.error}</Typography>
                                                    }
                                                    {
                                                        !!loadError &&
                                                        <Typography>{t('somethingWentWrong')}</Typography>
                                                    }
                                                    <Typography >{page.description}</Typography>
                                                </Grid>
                                                <Grid item size={12}>
                                                    <div className={`paymentCard ${page.status}`}>
                                                        <Typography className="flex-space mb-10">{t('amount')}: <strong>{price(page.amount)} {currencySymbol}</strong></Typography>
                                                        {
                                                            !!page.track_code &&
                                                            <Typography  className="flex-space mb-10">{t('track_code')}: <strong>{page.track_code}</strong></Typography>
                                                        }
                                                        <Typography  className="flex-space mb-10">{t('transactionCode')}: <strong>{page.unique_code}</strong></Typography>
                                                        <Typography  className="flex-space mb-10">{t('created_at')}: <strong>{showTableDate(page.created_at)}</strong></Typography>

                                                    </div>

                                                </Grid>
                                                <Grid item size={12} style={{display:"flex",justifyContent:"center",gap:10}}>
                                                    {
                                                        platform === 'web'  ?
                                                            <>
                                                                <Button
                                                                    component={Link}
                                                                    to="/"
                                                                    size="small"
                                                                    color="text"
                                                                >
                                                                    {t('backToHomePage')}
                                                                </Button>
                                                                {
                                                                    !!payment_redirect_url  &&
                                                                    <Button
                                                                        component={Link}
                                                                        endIcon={<ArrowRight/>}
                                                                        to={payment_redirect_url}
                                                                        variant="contained"
                                                                        color="secondary"
                                                                    >
                                                                        {payment_redirect_text}
                                                                    </Button>
                                                                }
                                                            </>
                                                            :
                                                            platform?.startsWith('android_') ? (
                                                                <>
                                                                    <Button
                                                                        component="a"
                                                                        href={`${
                                                                            platform === 'android_user'
                                                                                ? 'kolay-doy'
                                                                                : platform === 'android_transport'
                                                                                    ? 'kolay-doy-couriers'
                                                                                    : platform === 'android_supplier'
                                                                                        ? 'kolay-doy-vendors'
                                                                                        : ''
                                                                        }://?path=${source === 'wallet' ? 'wallet' : `orders`}`}
                                                                        variant="contained"
                                                                        color="secondary"
                                                                    >
                                                                        {t('backToApplication')}
                                                                    </Button>
                                                                </>
                                                            ) : null
                                                    }


                                                </Grid>

                                            </Grid>

                                    </Grid>
                                </Grid>
                            </Container>
                        </>

                }
            </div>
        </AppAnimate>
    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(PaymentResultPage));
